module.exports = __webpack_public_path__ + "static/img/6.2ba86e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/hospital1/6.png
// module id = 1/tS
// module chunks = 1